/* DIEREMA · panier latéral de luxe. JavaScript maison, sans bibliothèque, chargé en « defer ».
   - Tout vient du vrai panier Shopify : la section « dr-cart-data » (JSON) arrive avec chaque
     /cart/add.js et /cart/change.js (UNE requête par action) ou seule à l'ouverture (?sections=).
   - Le HTML et la feuille de style ne sont créés qu'à l'ouverture (la feuille est préchargée après
     le chargement de la page, sans rien bloquer).
   - Remplace le tiroir du thème : Alpine.store("cart").addToCart / showCart / hideCart / focusInCart.
     La page /cart reste celle de toujours.
   - Plusieurs « + » de suite = une seule requête (on attend 350 ms de calme). */
(function () {
  "use strict";
  var SCRIPT = document.currentScript || {};
  var CFG = (SCRIPT.dataset) || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var SECTION = "dr-cart-data";
  var SUR_PANIER = /\/cart\/?$/.test(location.pathname);
  var MAX = "Quantité maximale disponible atteinte";
  var ERR = "Connexion impossible pour le moment. Veuillez réessayer.";
  var COULEURS = { camel: "#B5824E", chocolat: "#36231D", noir: "#1E1B19", blanc: "#F4F1EA", cafe: "#5A3E2B",
    "cafe fonce": "#3F2A1E", taupe: "#8B7D6F", beige: "#D9C6A8", caramel: "#A86B3C", cognac: "#9A5A2C",
    bordeaux: "#5E1E28", vert: "#3F5A45", ecru: "#EEE6D3", avoine: "#D8C9A8", carmin: "#8E1F2A",
    chameau: "#B98B5A", "roux brun": "#7A4A2E", "rose eteint": "#C9A2A0", "orange kaki": "#A0713D" };

  var data = null, quand = 0, rac = null, ui = {}, ouvert = false, avantFocus = null, cssPret = null;
  var file = Promise.resolve(), attente = {}, vus = {}, dernierBouton = null, toastEl = null, toastT = 0;

  // ---------- petits outils ----------
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function sansAccent(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").trim(); }
  function lite() {
    var c = navigator.connection || {};
    return !!(c.saveData || /(^|-)2g|3g/.test(c.effectiveType || "") || (navigator.deviceMemory && navigator.deviceMemory <= 2)
      || (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches));
  }
  function toast(m) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "drc-toast"; toastEl.setAttribute("role", "status"); toastEl.setAttribute("aria-live", "polite"); document.body.appendChild(toastEl); chargerCss(); }
    toastEl.textContent = m; toastEl.classList.add("on");
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 2600);
  }

  // ---------- la feuille de style (et Bodoni Moda, déjà dans le thème) ----------
  function chargerCss() {
    if (cssPret) return cssPret;
    cssPret = new Promise(function (ok) {
      if (CFG.bodoni && !document.getElementById("drc-polices")) {
        var st = document.createElement("style"); st.id = "drc-polices";
        st.textContent = '@font-face{font-family:"Bodoni Moda";font-style:normal;font-weight:400;font-display:swap;src:url(' + CFG.bodoni + ') format("woff2")}'
          + '@font-face{font-family:"Bodoni Moda";font-style:italic;font-weight:400;font-display:swap;src:url(' + CFG.bodoniItalique + ') format("woff2")}';
        document.head.appendChild(st);
      }
      if (!CFG.css) return ok();
      var l = document.createElement("link"); l.rel = "stylesheet"; l.href = CFG.css;
      l.onload = l.onerror = function () { ok(); };
      document.head.appendChild(l);
      setTimeout(ok, 2500);
    });
    return cssPret;
  }

  // ---------- Shopify (une requête par action) ----------
  function lireSection(json) {
    var html = json && (json.sections ? json.sections[SECTION] : json[SECTION]);
    if (!html) throw new Error("section");
    var a = html.indexOf(">", html.indexOf("data-dr-cart")) + 1, b = html.lastIndexOf("</script>");
    return JSON.parse(html.slice(a, b));
  }
  function requete(chemin, corps) {
    var opts = corps
      ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(Object.assign({ sections: SECTION }, corps)) }
      : { headers: { Accept: "application/json" } };
    var url = corps ? ROOT + chemin : ROOT + "?sections=" + SECTION;
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.status === 422 || j.status === 422) { var e = new Error(j.description || j.message || "422"); e.code = 422; throw e; }
        if (!r.ok) throw new Error(r.status);
        return lireSection(j);
      });
    });
  }
  // Les requêtes passent une par une (jamais deux réponses dans le désordre).
  function enFile(f) { var p = file.then(f, f); file = p.catch(function () {}); return p; }
  function relire() { return enFile(function () { return requete(); }).then(appliquer); }

  // ---------- état ----------
  function appliquer(d, retarderTheme) {
    data = d; quand = Date.now();
    pastille(d.count);
    // Le chiffre du thème tout de suite ; ses articles (qui changent le bouton de la fiche en
    // « Déjà dans le panier ») un peu après, pour laisser voir « Ajouté ✓ ».
    try { if (window.Alpine) Alpine.store("main").totalCartQty = d.count; } catch (e) {}
    var sync = function () {
      try {
        var s = window.Alpine && Alpine.store("cart");
        // Les champs que le tiroir (caché) du thème lit, pour qu'il ne se plaigne pas.
        if (s && s.setCartItems) s.setCartItems(d.items.map(function (i) {
          return Object.assign({ properties: {}, line_level_discount_allocations: [], options_with_values: [],
            selling_plan_allocation: null, unit_price_measurement: null, gift_card: false,
            product_has_only_default_variant: !i.couleur, price: i.final_price, original_price: i.final_price },
            i, { title: i.titre, product_title: i.titre });
        }));
      } catch (e) {}
    };
    if (retarderTheme) setTimeout(sync, 1500); else sync();
    if (rac) rendu();
    return d;
  }
  var dernierCompte = null;
  function pastille(n) {
    n = Number(n) || 0;
    Array.prototype.forEach.call(document.querySelectorAll("[data-dr-bag-count]"), function (el) {
      el.textContent = n;
      el.classList.toggle("on", n > 0);
      if (dernierCompte !== null && n !== dernierCompte && n > 0) {
        el.classList.remove("saut"); void el.offsetWidth; el.classList.add("saut");
      }
    });
    dernierCompte = n;
  }

  // ---------- dates : aujourd'hui + 8 à 13 jours ouvrés (heure de Paris) ----------
  function dates() {
    try {
      var p = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date()).split("-");
      var auj = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
      var plus = function (n) { var x = new Date(auj); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); var w = x.getUTCDay(); if (w !== 0 && w !== 6) n--; } return x; };
      var a = plus(8), b = plus(13), f = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", timeZone: "UTC" });
      return a.getUTCMonth() === b.getUTCMonth() ? a.getUTCDate() + " – " + f.format(b) : f.format(a) + " – " + f.format(b);
    } catch (e) { return "8 à 13 jours ouvrés"; }
  }

  // ---------- le HTML (créé à la première ouverture) ----------
  var ICO_X = '<svg class="drc-i-x" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICO_FL = '<svg class="drc-i-fl" width="18" height="12" viewBox="0 0 24 14" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M1 7h21M16 1l6 6-6 6"/></svg>';
  function monter() {
    if (rac) return;
    rac = document.createElement("div");
    rac.className = "drc" + (lite() ? " lite" : "");
    rac.innerHTML = '<div class="drc-veil" data-drc-fermer></div>'
      + '<aside class="drc-drawer" role="dialog" aria-modal="true" aria-labelledby="drcTitre" aria-hidden="true">'
      + '<div class="drc-head"><div class="drc-mono">Dierema</div><h2 id="drcTitre">Votre sélection<small data-drc-n></small></h2>'
      + '<button class="drc-x" type="button" data-drc-fermer aria-label="Fermer le panier">' + ICO_X + '</button></div>'
      + '<div class="drc-journey" data-drc-ship hidden><div class="drc-t">Livraison offerte · colis suivi</div><div class="drc-steps">'
      + '<div class="drc-step done"><i></i><b>Aujourd\'hui</b>Commande</div><div class="drc-step"><i></i><b>1 à 3 jours</b>Préparation</div>'
      + '<div class="drc-step"><i></i><b data-drc-eta></b>Chez vous</div></div></div>'
      + '<div class="drc-body" data-drc-body></div>'
      + '<div class="drc-foot" data-drc-foot hidden><div class="drc-tot"><span>Total</span><strong data-drc-total></strong></div>'
      + '<div class="drc-tax">TTC · Livraison offerte en France métropolitaine</div>'
      + '<a class="drc-btn drc-pay" href="' + ROOT + 'checkout">Passer au paiement ' + ICO_FL + '</a>'
      + '<div class="drc-trust"><div><svg class="drc-i-t" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="1"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Paiement sécurisé</div>'
      + '<div><svg class="drc-i-t" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 12a8 8 0 1 0 3-6.2M4 4v4h4"/></svg>14 jours pour changer d\'avis</div></div>'
      + '<div class="drc-help">Une question ? <a href="mailto:contact@dierema.com">contact@dierema.com</a></div>'
      + '<button class="drc-cont" type="button" data-drc-fermer>Continuer mes achats</button></div></aside>';
    document.body.appendChild(rac);
    ui.drawer = rac.querySelector(".drc-drawer");
    ["n", "ship", "eta", "body", "foot", "total"].forEach(function (k) { ui[k] = rac.querySelector("[data-drc-" + k + "]"); });
    ui.eta.textContent = dates();
    rac.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target : e.target.parentNode;
      if (t.closest("[data-drc-fermer]")) { fermer(); return; }
      var b = t.closest("button[data-act]");
      if (!b) return;
      var cle = b.getAttribute("data-key");
      if (b.dataset.act === "moins") changer(cle, -1);
      else if (b.dataset.act === "plus") changer(cle, 1);
      else if (b.dataset.act === "retirer") retirer(cle, b);
      else if (b.dataset.act === "sugg") { b.setAttribute("aria-busy", "true"); ajouter([{ id: Number(b.getAttribute("data-id")), quantity: 1 }], false).then(null, function () {}).then(function () { b.removeAttribute("aria-busy"); }); }
      else if (b.dataset.act === "relire") { ui.body.innerHTML = ""; relire().catch(erreurOuverture); }
    });
    // Le voile ne laisse pas défiler la page derrière (iPhone compris).
    rac.querySelector(".drc-veil").addEventListener("touchmove", function (e) { e.preventDefault(); }, { passive: false });
  }

  function couleurPoint(nom, image) {
    var hex = COULEURS[sansAccent(nom)];
    if (hex) return "background:" + hex;
    return image ? "background-image:url(" + esc(image) + ")" : "background:#CFC6BC";
  }
  function rendu() {
    if (!data) return;
    var n = data.count;
    ui.n.textContent = n ? n + (n > 1 ? " articles" : " article") : "";
    ui.ship.hidden = ui.foot.hidden = !n;
    if (!n) {
      ui.body.innerHTML = '<div class="drc-empty"><p>Votre panier est vide</p><span>Nos sacs vous attendent.</span>'
        + '<a class="drc-btn" href="' + ROOT + 'collections/sacs">Découvrir la collection</a></div>';
      vus = {};
      return;
    }
    ui.total.textContent = data.total;
    var h = "", nouveaux = {};
    // Dans l'ordre où on les a ajoutés (Shopify donne le plus récent en premier).
    data.items.slice().reverse().forEach(function (it) {
      var q = attente[it.key] ? attente[it.key].q : it.quantity;
      var neuf = !vus[it.key];
      nouveaux[it.key] = 1;
      h += '<div class="drc-item' + (neuf ? " neuf" : "") + (q === 0 ? " part" : "") + '" data-key="' + esc(it.key) + '">'
        + '<a class="drc-thumb" href="' + esc(it.url) + '" tabindex="-1">' + (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.titre + (it.couleur ? ", coloris " + it.couleur.toLowerCase() : "")) + '" width="240" height="300" loading="lazy" decoding="async">' : "") + '</a>'
        + '<div><div class="drc-row"><h3><a href="' + esc(it.url) + '">' + esc(it.titre) + '</a></h3><div class="drc-lineprice">' + esc(it.prix) + '</div></div>'
        + (it.couleur ? '<div class="drc-meta"><span class="drc-dot" style="' + couleurPoint(it.couleur, it.image) + '"></span>' + esc(it.couleur) + '</div>' : '<div class="drc-meta"></div>')
        + '<div><span class="drc-qty"><button type="button" data-act="moins" data-key="' + esc(it.key) + '" aria-label="Retirer un">−</button><output aria-live="polite">' + q + '</output>'
        + '<button type="button" data-act="plus" data-key="' + esc(it.key) + '" aria-label="Ajouter un">+</button></span>'
        + '<button class="drc-rm" type="button" data-act="retirer" data-key="' + esc(it.key) + '">Retirer</button></div></div></div>';
    });
    vus = nouveaux;
    var s = data.suggestion;
    if (s) {
      h += '<div class="drc-also"><h4>Existe aussi en ' + esc(String(s.couleur).toLowerCase()) + '</h4><div class="drc-card">'
        + (s.image ? '<img src="' + esc(s.image) + '" alt="' + esc(s.titre + ", coloris " + String(s.couleur).toLowerCase()) + '" width="72" height="72" loading="lazy" decoding="async">' : "<span></span>")
        + '<div><b>' + esc(s.titre) + '</b><span>' + esc(s.couleur) + " · " + esc(s.prix) + '</span></div>'
        + '<button class="drc-add" type="button" data-act="sugg" data-id="' + s.id + '">Ajouter</button></div></div>';
    }
    ui.body.innerHTML = h;
  }
  function erreurOuverture() {
    if (!rac) return;
    if (!data) {
      ui.ship.hidden = ui.foot.hidden = true;
      ui.body.innerHTML = '<div class="drc-msg">Votre panier ne répond pas pour le moment.<br><button type="button" data-act="relire">Réessayer</button></div>';
    } else toast(ERR);
  }

  // ---------- ouvrir / fermer ----------
  function ouvrir() {
    if (SUR_PANIER) { location.href = ROOT + "cart"; return; }
    monter();
    var vieux = !data || Date.now() - quand > 1500;
    if (vieux && !data) ui.body.innerHTML = "";
    if (vieux) relire().catch(erreurOuverture);
    rendu();
    if (ouvert) return;
    ouvert = true;
    avantFocus = document.activeElement;
    document.documentElement.classList.add("dr-cart-open");
    chargerCss().then(function () {
      if (!ouvert) return;
      ui.drawer.setAttribute("aria-hidden", "false");
      requestAnimationFrame(function () { rac.classList.add("on"); });
      setTimeout(function () { var x = rac.querySelector(".drc-x"); if (ouvert && x) x.focus({ preventScroll: true }); }, 320);
    });
  }
  function fermer() {
    if (!ouvert) return;
    ouvert = false;
    rac.classList.remove("on");
    ui.drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("dr-cart-open");
    if (avantFocus && avantFocus.focus) try { avantFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener("keydown", function (e) {
    if (!ouvert) return;
    if (e.key === "Escape") { fermer(); return; }
    if (e.key === "Tab") {
      var f = Array.prototype.filter.call(ui.drawer.querySelectorAll("a[href],button"), function (x) { return x.offsetParent && x.tabIndex !== -1; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  // ---------- actions ----------
  function ajouter(items, ouvrirApres) {
    var s = null;
    try { s = window.Alpine && Alpine.store("cart"); } catch (e) {}
    var ids = items.map(function (i) { return Number(i.id); });
    if (s && s.addingItemIds) ids.forEach(function (id) { if (s.addingItemIds.indexOf(id) < 0) s.addingItemIds.push(id); });
    var fin = function () { if (s && s.addingItemIds) s.addingItemIds = s.addingItemIds.filter(function (id) { return ids.indexOf(id) < 0; }); };
    var bouton = dernierBouton && Date.now() - dernierBouton.t < 6000 ? dernierBouton.el : null;
    return enFile(function () { return requete("cart/add.js", { items: items }); }).then(function (d) {
      fin();
      appliquer(d, true);
      if (ouvrirApres === false) toast("Ajouté au panier");
      else {
        if (bouton && /ajout|panier/i.test(bouton.textContent || "")) {
          bouton.style.setProperty("--dr-ajoute-c", getComputedStyle(bouton).color);
          bouton.classList.add("dr-ajoute");
          setTimeout(function () { bouton.classList.remove("dr-ajoute"); }, 1400);
        }
        ouvrir();
      }
      return d;
    }, function (e) {
      fin();
      toast(e.code === 422 ? MAX : ERR);
      if (e.code === 422) relire().catch(function () {});
      throw e;
    });
  }
  function trouver(cle) { return data && data.items.filter(function (i) { return i.key === cle; })[0]; }
  function montrerQte(cle, q) {
    var el = ui.body && ui.body.querySelector('.drc-item[data-key="' + (window.CSS && CSS.escape ? CSS.escape(cle) : cle) + '"]');
    if (!el) return;
    el.querySelector("output").textContent = q;
    el.classList.toggle("part", q === 0);
  }
  function changer(cle, delta) {
    var it = trouver(cle);
    if (!it) return;
    var q = (attente[cle] ? attente[cle].q : it.quantity) + delta;
    if (q < 0) q = 0;
    if (delta > 0 && it.max != null && q > it.max) { toast(MAX); return; }
    attente[cle] = attente[cle] || {};
    attente[cle].q = q;
    montrerQte(cle, q);
    clearTimeout(attente[cle].t);
    attente[cle].t = setTimeout(function () { envoyer(cle); }, 350);
  }
  function envoyer(cle, toastFin) {
    var a = attente[cle];
    if (!a) return Promise.resolve();
    clearTimeout(a.t);
    delete attente[cle];
    return enFile(function () { return requete("cart/change.js", { id: cle, quantity: a.q }); }).then(function (d) {
      appliquer(d);
      if (toastFin) toast(toastFin);
    }, function (e) {
      toast(e.code === 422 ? MAX : ERR);
      relire().catch(function () { rendu(); });
    });
  }
  function retirer(cle) {
    attente[cle] = attente[cle] || {};
    attente[cle].q = 0;
    montrerQte(cle, 0);
    envoyer(cle, "Article retiré");
  }

  // ---------- branchements ----------
  // Le dernier bouton touché (pour « Ajouté ✓ » sur le bon bouton).
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("button,a") : null;
    if (b && !(rac && rac.contains(b))) dernierBouton = { el: b, t: Date.now() };
  }, true);
  // Le tiroir du thème est remplacé par celui-ci (sauf sur la page /cart, qui reste la même).
  document.addEventListener("alpine:init", function () {
    if (SUR_PANIER) return;
    var s;
    try { s = Alpine.store("cart"); } catch (e) { return; }
    if (!s) return;
    s.addToCart = function (props) { ajouter([props]).catch(function () {}); };
    s.showCart = ouvrir;
    s.focusInCart = ouvrir;
    s.hideCart = fermer;
  });
  // Le chiffre de la cabine suit aussi les changements faits par le thème (fiche produit).
  document.addEventListener("alpine:initialized", function () {
    try {
      Alpine.effect(function () {
        var n = Alpine.store("main").totalCartQty;
        if (data && n !== data.count) quand = 0; // le panier a changé ailleurs : on relira à l'ouverture
        pastille(n);
      });
    } catch (e) {}
  });
  // Feuille de style mise en cache (prefetch : téléchargée, PAS appliquée, donc aucun recalcul de la
  // page) une fois la page chargée, quand le navigateur est libre. Elle s'applique à la 1re ouverture.
  window.addEventListener("load", function () {
    var go = function () {
      if (SUR_PANIER || cssPret || !CFG.css) return;
      var l = document.createElement("link"); l.rel = "prefetch"; l.as = "style"; l.href = CFG.css;
      document.head.appendChild(l);
    };
    if ("requestIdleCallback" in window) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500);
  });
  window.drCart = { ouvrir: ouvrir, fermer: fermer, ajouter: ajouter, relire: relire, etat: function () { return data; } };
})();
